/* eslint-disable */
export default {
  log: '記錄',
} as const;

// @key: @#@"log"@#@ @source: @#@"Log"@#@
